import { ref, shallowRef } from "vue";

export interface PopupDialogButton {
    title: string;
    callback?: () => void | Promise<unknown>;
    link?: string;
    design?: "outline-red" | "outline-blue";
}

export enum PopupDialogEnum {
    info = "info",
    warning = "warning",
    alert = "alert",
    success = "success",
}

export type PopupDialogType = "info" | "warning" | "alert" | "success";

export interface PopupDialogOptions {
    message: string;
    buttons: PopupDialogButton[];
    type: PopupDialogType;
    closeOnOutsideClick?: boolean;
}

class PopupDialogModel {
    show = shallowRef(false);
    isLoginPopupOpen = shallowRef(false);
    message = shallowRef("");
    buttons = ref<PopupDialogButton[]>([]);
    type = shallowRef<PopupDialogType>(PopupDialogEnum.info);
    closeOnOutsideClick = shallowRef(true);
    showCloseButton = shallowRef(true);

    showPopup(options: PopupDialogOptions) {
        this.show.value = true;
        this.isLoginPopupOpen.value = false;
        this.message.value = options.message;
        this.buttons.value = options.buttons;
        this.type.value = options.type;
        this.closeOnOutsideClick.value = options.closeOnOutsideClick || true;
    }

    showLoginPopup(text: string, closable = true) {
        this.message.value = text;
        this.show.value = true;
        this.isLoginPopupOpen.value = true;
        this.closeOnOutsideClick.value = closable;
        this.showCloseButton.value = closable;
    }
}

export const popupDialogModel = new PopupDialogModel();
